module.exports = "https://www.gc-qa.gnp.com.mx/9c521d143ea3d1cfc8326894e05b2c96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-beneficiario.svg
// module id = 376
// module chunks = 0